import React from 'react'
import { Link } from 'react-router-dom'
import Svg from '../../../../component/Svg'
import Button from "../../../../core/Button";
import Input from "../../../../core/Inputs/DefaultInput";

export default function Index() {
    return (
        <>
            <div className='d-flex flex-column site-main-wrapper login-page'>
                <div className="flex-grow-1 main-content-wrap d-flex align-items-center justify-content-center">
                    <div className="container">
                        <div className="form-outer-wrapper">
                            <div className="logo-wrap text-center">
                                <Link to="/#0t" className='home-logo'>
                                    <Svg name="logo" />
                                </Link>
                            </div>
                            <div className="form-wrapper team-invitation-pg">
                                <div className="row align-items-center">
                                    <div className="col-lg-5">
                                        <div className="form-left">
                                            <div className="form-heading mb-4">
                                                <h3>Who’s on your team?</h3>
                                                <p className='ms-0'>Bring your whole team to collaborate and unlock the full power of Digital Apple together.</p>
                                            </div>
                                            <div className="get-invite-url mb-4">
                                                <Link className='btn link-btn' to=""><Svg name="invite-link" />Get invite link</Link>
                                            </div>
                                            <div className="field-wrapper">
                                                <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                                                    < Input
                                                        type='text'
                                                        view='outlined'
                                                        dense={false}
                                                        color='default'
                                                        label=''
                                                        placeholder='Enter email address'
                                                        clearButton={true}
                                                        success={false}
                                                        error={false}
                                                        fill={true}
                                                        errorHelperText={null}
                                                        className={"formsinput"}
                                                        value="nishank@digitalapple.in"
                                                        name="email"
                                                    />
                                                    <div className="validation-msg">This is not a valid email</div>
                                                </div>
                                                <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                                                    < Input
                                                        type='text'
                                                        view='outlined'
                                                        dense={false}
                                                        color='default'
                                                        label=''
                                                        placeholder='Enter email address'
                                                        clearButton={true}
                                                        success={false}
                                                        error={false}
                                                        fill={true}
                                                        errorHelperText={null}
                                                        className={"formsinput"}
                                                        value="surojit@gigitalapple.in"
                                                        name="email"
                                                    />
                                                    <div className="validation-msg">This is not a valid email</div>
                                                </div>
                                                <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                                                    < Input
                                                        type='text'
                                                        view='outlined'
                                                        dense={false}
                                                        color='default'
                                                        label=''
                                                        placeholder='Enter email address'
                                                        clearButton={true}
                                                        success={false}
                                                        error={false}
                                                        fill={true}
                                                        errorHelperText={null}
                                                        className={"formsinput"}
                                                        name="email"
                                                    />
                                                    <div className="validation-msg">This is not a valid email</div>
                                                </div>
                                                <div className="mb__20 position-relative"> {/* Add Class error to this div once error occurs and if its valid, add class success*/}
                                                    < Input
                                                        type='text'
                                                        view='outlined'
                                                        dense={false}
                                                        color='default'
                                                        label=''
                                                        placeholder='Enter email address'
                                                        clearButton={true}
                                                        success={false}
                                                        error={false}
                                                        fill={true}
                                                        errorHelperText={null}
                                                        className={"formsinput"}
                                                        name="email"
                                                    />
                                                    <div className="validation-msg">This is not a valid email</div>
                                                </div>
                                                <div className="mb-4">
                                                    <button className='add-email'><Svg name="plus"/> Add another </button>
                                                </div>


                                            </div>
                                            <div className="button-wrap mb-0">
                                                <Button className={"formsbutton btn-primnary mb-0"}
                                                    type="default"
                                                    view="filled"
                                                    color="primary"
                                                    text="Send invitations"
                                                    fill={true}
                                                />
                                                {/* </Link> */}
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-lg-7">
                                        <div className="team-info">
                                            <div className="team-icon text-center">
                                                <Svg name="team-icon" />
                                            </div>
                                            <div className="team-text">
                                                <ul>
                                                    <li>Access your team’s shared surveys from one place, whenever needed.</li>
                                                    <li>Collaborate and get things done faster with shared surveys </li>
                                                    <li>Provide feedback on design and copy directly - no more emailing back and forth.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
